import { parse } from "node-html-parser";

/**
 * @param {string} html
 * @param {string} [title]
 * @returns {{ title: string, columns: string[], rows: (string|null)[][] }|null}
 */
export function parseTableHtml(html, title = "Detected Table") {
  const root = parse(html);
  const rowEls = root.querySelectorAll("tr");
  if (rowEls.length === 0) return null;

  const grid = [];
  const pending = [];

  rowEls.forEach((rowEl, rowIndex) => {
    grid[rowIndex] = grid[rowIndex] ?? [];

    for (const p of pending) {
      if (p.rowsLeft > 0) {
        grid[rowIndex][p.col] = p.value;
      }
    }

    const cellEls = rowEl.querySelectorAll("td,th");
    let col = 0;

    for (const cellEl of cellEls) {
      while (grid[rowIndex][col] !== undefined) col += 1;

      const text = cellEl.text.trim() || null;
      const colspan = parseInt(cellEl.getAttribute("colspan") ?? "1", 10);
      const rowspan = parseInt(cellEl.getAttribute("rowspan") ?? "1", 10);

      for (let c = 0; c < colspan; c += 1) {
        grid[rowIndex][col + c] = text;
      }

      if (rowspan > 1) {
        for (let c = 0; c < colspan; c += 1) {
          pending.push({ col: col + c, value: text, rowsLeft: rowspan - 1 });
        }
      }

      col += colspan;
    }

    for (const p of pending) p.rowsLeft -= 1;
  });

  if (grid.length === 0) return null;

  const width = Math.max(...grid.map((r) => r.length));
  const normalized = grid.map((r) =>
    Array.from({ length: width }, (_, i) => r[i] ?? null),
  );

  const columns = normalized[0].map((_, i) => `Column ${i + 1}`);
  const rows = normalized.slice(1);

  return { title, columns, rows };
}
